import classNames from "classnames";
import { memo } from "react";
import { Flex } from "./flex";
import * as styles from "./product-list-row.module.css";
import { Text } from "./text";

export const ProductListItemQuantity = memo(function ProductListItemQuantity({
  emphasizeQuantity,
  quantity,
  price,
}: {
  emphasizeQuantity: boolean;
  quantity: number;
  price: string;
}) {
  return (
    <>
      {emphasizeQuantity ? (
        <Flex
          align="center"
          className={classNames(
            styles.quantityContainer,
            quantity > 1 && styles.emphasizeQuantity,
          )}
          justify="center"
        >
          <Text
            fontSize="md"
            fontWeight={quantity > 1 ? "bold" : "regular"}
            textColor={quantity > 1 ? "white" : "tertiary"}
          >
            {quantity}
          </Text>
        </Flex>
      ) : (
        <Flex
          flexDirection="column"
          gap="xs"
          justify="center"
          pr="xl"
          textAlign="right"
        >
          <Text fontSize="xs" fontWeight="medium">
            {price}
          </Text>
          <Text fontSize="xxs" textColor="tertiary">
            Quantity: {quantity}
          </Text>
        </Flex>
      )}
    </>
  );
});
